import { render, staticRenderFns } from "./UserPageAuthorized.vue?vue&type=template&id=b6ea4da6&scoped=true"
import script from "./UserPageAuthorized.vue?vue&type=script&lang=js"
export * from "./UserPageAuthorized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ea4da6",
  null
  
)

export default component.exports